// src/components/Header.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import './Header.css';

const Header = () => {
  const { userName, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="header">
      <h1 className="logo-text">DOG SHOW CATALOGUE</h1>

      <div className="user-info">
        {userName ? (
          <div className="login-status">
            <span className="login-user">
              <span className="login-prefix">ログイン：</span>
              <span className="login-user-name">{userName}</span>
              <span>&nbsp;様</span>
            </span>
            <button className="logout-button" onClick={handleLogout}>
              ログアウト
            </button>
          </div>
        ) : (
          <p>ゲスト</p>
        )}
      </div>
    </div>
  );
};

export default Header;
